import React, { Component } from "react";
import { encryptData } from "./utils/encryptionUtils";
import { getClientId } from "./utils/analyticsclientIdUtils";

import ZPartnerLSC0Header from "./ZPartnerLSC0Header";
import ZPartnerLSC0Footer from "./ZPartnerLSC0Footer";

import { Redirect_Url_2 } from "./ZPartnerLSCUrls";
import { validatePassword } from './utils/validatePassword';
export class LSC_JoinNowAction extends Component {
    static displayName = LSC_JoinNowAction.name;

    constructor(props) {
        super(props);
        this.state = {
            message: "",
            submitting: false,
            actionid: "",

            email: "",
            Password: "",
            ConfirmPassword: "",
            Salutation: "",
            Name: "",
            Lastname: "",
            NameTH: "",
            LastnameTH: "",
            Mobile: "",
            BirthdayD: "",
            BirthdayM: "",
            Terms01: false,
            Terms02: false,
            showPassword: false,
            showConfirmPassword: false,
            showPasswordHint: false,
            showBirthdayModal: false,
            isLoading: true
        };
    }

    fetchPreload = async (actionid) => {        
        const timestamp = Math.floor(Date.now() / 1000);

        const payload = {
            ActionId: actionid,
            RefLang: "en",
            Timestamp: timestamp
        };

        const encryptedPayload = encryptData(payload);

        try {
            const response = await fetch("/api/ZPartnerLSCJoinnowStep02", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
            });

            const data = await response.json();

            if (data.responseCode === "00") {
                const email = data.email || "";

                this.setState({
                    email,
                    isLoading: false // set isLoading for complete loading
                });
            } else {
                sessionStorage.setItem("lscErrorMsg", "Error when loading data");
                window.location.replace("/line_err01");
            }
        } catch (error) {
            console.error("Preload error:", error);
            sessionStorage.setItem("lscErrorMsg", "System error");
            window.location.replace("/line_err01");
        }
    };


    componentDidMount() {
        //const links = [
        //    "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
        //    "/css/lsc/style_01.css",
        //    "/css/lsc/style_02.css",
        //    "/css/lsc/style_03.css",
        //    "/css/lsc/691208892_en-US.css",
        //    "/css/lsc/line_my_card.css"
        //];

        //links.forEach(href => {
        //    const link = document.createElement("link");
        //    link.rel = "stylesheet";
        //    link.href = href;
        //    document.head.appendChild(link);
        //});

        // Read query string parameters
        const params = new URLSearchParams(window.location.search);
        const actionid = params.get("actionid");
        // If any required parameter is missing, redirect to error page
        if (!actionid) {
            sessionStorage.setItem("lscErrorMsg", "Missing param action!!");
            window.location.replace("/line_err01");
            return;
        }

        this.setState({
            actionid: actionid
        });

        // check actionid is exists
        this.fetchPreload(actionid);

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "LSC_Joinnow_Action";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });

        // #region "back button / history handling"
        if (typeof window !== "undefined" && window.history && window.history.pushState) {
            // keep reference for removeEventListener later
            this.handlePopState = () => {
                const hashLocation = window.location.hash;
                const hashSplit = hashLocation.split("#!/");
                const hashName = hashSplit[1];

                if (hashName !== "") {
                    const hash = window.location.hash;
                    if (hash === "") {
                        window.location = Redirect_Url_2;
                        return false;
                    }
                }
            };

            window.addEventListener("popstate", this.handlePopState);

            // same as original: push fake state into history
            window.history.pushState("forward", null, "./#forward");
        }
        // #endregion
    }

    handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        this.setState({
            [name]: type === "checkbox" ? checked : value
        });
    };

    togglePasswordVisibility = () => {
        this.setState((prev) => ({
            showPassword: !prev.showPassword
        }));
    };

    toggleConfirmPasswordVisibility = () => {
        this.setState((prev) => ({
            showConfirmPassword: !prev.showConfirmPassword
        }));
    };

    handlePasswordFocus = () => {
        this.setState({ showPasswordHint: true });
    };

    handlePasswordBlur = () => {
        this.setState({ showPasswordHint: false });
    };

    closeBirthdayModal = () => {
        this.setState({ showBirthdayModal: false });
    };

    confirmSkipBirthday = () => {
        // User selects "No/Yes" -> closes modal then fires API.
        this.setState({ showBirthdayModal: false }, () => {
            this.submitToApi();
        });
    };

    goFillBirthday = () => {
        // User selects "Enter/No" -> close modal and focus on birthday.
        this.setState({ showBirthdayModal: false }, () => {
            const el = document.getElementById("BirthdayD");
            if (el) {
                el.focus();
            }
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        console.log(this.state);

        const {
            Name,
            Lastname,
            Password,
            ConfirmPassword,
            BirthdayD,
            BirthdayM,
            Terms01,
            Terms02
        } = this.state;

        this.setState({
            loginstatus: ""
        });

        const errors = validatePassword(Password);
        if (errors) {
            this.setState({
                loginstatus: errors,
                submitting: false
            });
            return;
        }

        // Basic validation
        if (!Name?.trim() ||
            !Lastname?.trim() ||
            !Password?.trim() ||
            !ConfirmPassword?.trim() ||
            Password !== ConfirmPassword
        ) {
            this.setState({
                loginstatus: "Please check required information / กรุณาตรวจสอบข้อมูลให้ถูกต้องและครบถ้วน",
                submitting: false
            });
            return;
        }

        // Terms validation
        if (!Terms01) {
            this.setState({
                loginstatus: "Please accept Terms and Conditions / กรุณายอมรับเงื่อนไข",
                submitting: false
            });
            return;
        }

        // Terms02 if required
        // if (!Terms02) {
        //     this.setState({
        //         loginstatus: "Please accept marketing consent",
        //         submitting: false
        //     });
        //     return;
        // }

        // If the birth date or month is empty -> Open the Ask modal first.
        if (!BirthdayD || !BirthdayM) {
            this.setState({ showBirthdayModal: true });
            return;
        }

        this.submitToApi();
    };

    submitToApi = async () => {
        const {
            actionid,
            Password,
            ConfirmPassword,
            Salutation,
            Name,
            Lastname,
            NameTH,
            LastnameTH,
            Mobile,
            BirthdayD,
            BirthdayM,
            Terms01,
            Terms02
        } = this.state;

        // Prevent double submit
        this.setState({ submitting: true });
        document.body.classList.add("wait-cursor");

        const timestamp = Math.floor(Date.now() / 1000);

        // Payload for api
        const payload = {
            ActionId: actionid,
            Password,
            ConfirmPassword,
            Salutation,
            Name,
            Lastname,
            NameTH,
            LastnameTH,
            Mobile,
            BirthdayD: BirthdayD === "" ? null : BirthdayD,
            BirthdayM: BirthdayM === "" ? null : BirthdayM,
            Terms01,
            Terms02,
            RefLang: "en",
            Timestamp: timestamp
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/ZPartnerLSCJoinnowStep03`, requestOptions);
            const data = await response.json();

            if (data.responseCode === "00") {
                const message = (data.responseMessage || "").toLowerCase();
                sessionStorage.setItem("signinMessage", message);

                document.body.classList.remove("wait-cursor");

                // Redirect after successful signin
                switch (message) {
                    case "success":
                        window.location.replace("/line_joinnow_success");
                        break;
                    case "error-failcreatecrmprofile":
                        sessionStorage.setItem("lscErrorMsg", "FailCreateCrmProfile");
                        window.location.replace("/line_err01");
                        break;
                    default:
                        window.location.replace("/");
                        break;
                }
            } else {
                document.body.classList.remove("wait-cursor");

                sessionStorage.setItem("lscErrorMsg", "Error occur !!");
                window.location.replace("/line_err01");
            }
        } catch (error) {
            console.error("Error during LineSignin API:", error);
            this.setState({
                loginstatus: "Unexpected error occurred",
                submitting: false
            });

            document.body.classList.remove("wait-cursor");
        }
    };

    render() {
        const {
            submitting,
            email,
            Password,
            ConfirmPassword,
            Salutation,
            Name,
            Lastname,
            NameTH,
            LastnameTH,
            Mobile,
            BirthdayD,
            BirthdayM,
            Terms01,
            Terms02,
            showPassword,
            showConfirmPassword,
            showPasswordHint,
            showBirthdayModal,
            isLoading,
            loginstatus
        } = this.state;

        if (isLoading) {
            // while loading
            return (
                <div>
                    Loading...
                </div>
            );
        }

        return (
            <>
                <ZPartnerLSC0Header />

                <main id="main">
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 text-center">
                                    <h2 className="h3 mt-5 fw-bold text-dark-212121">
                                        ข้อมูลเพื่อเข้าสู่ระบบ<br />
                                        Login Data
                                    </h2>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <form className="form-sr px-1 px-md-4" onSubmit={this.handleSubmit}>
                                            <div className="mb-4">
                                                <label htmlFor="exampleInputEmail1" className="form-label d-none">อีเมล / Email</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="อีเมล / Email"
                                                    name="email"
                                                    value={email}
                                                    onChange={this.handleChange}
                                                    readOnly
                                                />
                                                <p className="small mt-2">อีเมลเพื่อเข้าสู่บัญชีของคุณ / This Will be your username.</p>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="exampleInputPassword1" className="form-label d-none">รหัสผ่าน / Password</label>
                                                <div className="input-group mb-3">
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        className="form-control border-end-0"
                                                        placeholder="รหัสผ่าน / Password"
                                                        name="Password"
                                                        value={Password}
                                                        onChange={this.handleChange}
                                                        onFocus={this.handlePasswordFocus}
                                                        onBlur={this.handlePasswordBlur}
                                                    />
                                                    <span className="input-group-text">
                                                        <i
                                                            className={
                                                                showPassword ? "fa fa-fw fa-eye toggle-password" : "fa fa-fw fa-eye-slash toggle-password"
                                                            }
                                                            onClick={this.togglePasswordVisibility}
                                                        ></i>
                                                    </span>
                                                </div>

                                                {showPasswordHint && (
                                                    <div id="show_hide_hint_pass">
                                                        <strong style={{ textDecoration: "underline" }}>Password Tips</strong>
                                                        <ul className="show_hide_hint_pass_ul">
                                                            <li>
                                                                <span className="Sarabun_fontthai">
                                                                    ความยาวรหัสตั้งแต่ 9 ถึง 15 ตัวอักษร
                                                                </span>
                                                                <br />
                                                                From 9 to 15 characters
                                                            </li>
                                                            <li>
                                                                <span className="Sarabun_fontthai">
                                                                    ประกอบด้วยตัวเลขอย่างน้อยหนึ่งตัว
                                                                </span>
                                                                <br />
                                                                At least one number
                                                            </li>
                                                            <li>
                                                                <span className="Sarabun_fontthai">
                                                                    ประกอบด้วยตัวอักษรพิมพ์ใหญ่อย่างน้อยหนึ่งตัวอักษร
                                                                </span>
                                                                <br />
                                                                At least one capital letter
                                                            </li>
                                                            <li>
                                                                <span className="Sarabun_fontthai">
                                                                    ประกอบด้วยตัวอักษรพิมพ์เล็กอย่างน้อยหนึ่งตัวอักษร
                                                                </span>
                                                                <br />
                                                                At least one lower case letter
                                                            </li>
                                                            <li>
                                                                <span className="Sarabun_fontthai">
                                                                    ประกอบด้วยตัวอักษรพิเศษอย่างน้อยหนึ่งตัวอักษร เช่น !,@@,#,$,*,;,&
                                                                </span>
                                                                <br />
                                                                At least one Special characters eg. !,@@,#,$,*,;,&amp;
                                                            </li>
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="exampleInputPassword1" className="form-label d-none">ยืนยันรหัสผ่าน / Confirm Password</label>
                                                <div className="input-group mb-3">
                                                    <input
                                                        type={showConfirmPassword ? "text" : "password"}
                                                        className="form-control border-end-0"
                                                        placeholder="ยืนยันรหัสผ่าน / Confirm Password"
                                                        name="ConfirmPassword"
                                                        value={ConfirmPassword}
                                                        onChange={this.handleChange}
                                                    />
                                                    <span className="input-group-text">
                                                        <i
                                                            className={
                                                                showPassword ? "fa fa-fw fa-eye toggle-password" : "fa fa-fw fa-eye-slash toggle-password"
                                                            }
                                                            onClick={this.toggleConfirmPasswordVisibility}
                                                        ></i>
                                                    </span>
                                                </div>
                                            </div>
                                            <hr />
                                            <p className="mt-4 mb-3">
                                                <strong>
                                                    ข้อมูลของคุณ<br />
                                                    Personal Particulars
                                                </strong>
                                            </p>
                                            <div className="mb-3">
                                                <label htmlFor="Salutation" className="form-label">คำนำหน้าชื่อ/PREFIX (OPTIONAL)</label>
                                                <select
                                                    className="form-select"
                                                    name="Salutation"
                                                    value={Salutation}
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">
                                                        กรุณาเลือก / Please select
                                                    </option>
                                                    <option value="Mr.">นาย / Mr.</option>
                                                    <option value="Mrs.">นาง / Mrs.</option>
                                                    <option value="Ms">นางสาว / Ms.</option>
                                                </select>
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label d-none">ชื่อ(ภาษาอังกฤษ)/Name (English)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="ชื่อ(ภาษาอังกฤษ)/Name (English)"
                                                    name="Name"
                                                    maxLength={30}
                                                    value={Name}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label d-none">นามสกุล(ภาษาอังกฤษ)/Last Name (English)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="นามสกุล(ภาษาอังกฤษ)/Last Name (English)"
                                                    name="Lastname"
                                                    maxLength={30}
                                                    value={Lastname}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label d-none">ชื่อ (ภาษาไทย) (optional)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="ชื่อ (ภาษาไทย) (optional)"
                                                    name="NameTH"
                                                    maxLength={30}
                                                    value={NameTH}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label d-none">นามสกุล (ภาษาไทย) (optional)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="นามสกุล (ภาษาไทย) (optional)"
                                                    name="LastnameTH"
                                                    maxLength={30}
                                                    value={LastnameTH}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <div className="mb-3">
                                                <label className="form-label d-none">เบอร์โทรศัพท์ / Mobile Number (optional)</label>
                                                <input
                                                    type="tel"
                                                    className="form-control"
                                                    placeholder="เบอร์โทรศัพท์ / Mobile Number (optional)"
                                                    name="Mobile"
                                                    value={Mobile}
                                                    onChange={this.handleChange}
                                                />
                                            </div>
                                            <hr />
                                            <div className="mt-4">
                                                <p><strong>วันเกิด / BIRTHDAY (OPTIONAL)</strong></p>
                                                <p className="text-xxs"><span className="Sarabun_fontthai">คุณจะได้รับสิทธิพิเศษในเดือนเกิดเมื่อคุณปรับระดับเป็น Gold</span><br />Make your birthday special once you reach Gold level with a reward on us.</p>
                                                <div className="row mb-4">
                                                    <div className="col-6">
                                                        <select
                                                            className="Sarabun_fontthai"
                                                            name="BirthdayD"
                                                            value={BirthdayD}
                                                            onChange={this.handleChange}
                                                        >
                                                            <option value="">วัน / Day</option>
                                                            {Array.from({ length: 31 }).map(
                                                                (_, i) => (
                                                                    <option key={i + 1} value={i + 1}>
                                                                        {i + 1}
                                                                    </option>
                                                                )
                                                            )}
                                                        </select>
                                                    </div>
                                                    <div className="col-6">
                                                        <select
                                                            className="Sarabun_fontthai"
                                                            name="BirthdayM"
                                                            value={BirthdayM}
                                                            onChange={this.handleChange}
                                                        >
                                                            <option value="">เดือน /  Month</option>
                                                            <option value="01">ม.ค. / Jan</option>
                                                            <option value="02">ก.พ. / Feb</option>
                                                            <option value="03">มี.ค. / Mar</option>
                                                            <option value="04">เม.ษ. / Apr</option>
                                                            <option value="05">พ.ค. / May</option>
                                                            <option value="06">มิ.ย. / Jun</option>
                                                            <option value="07">ก.ค. / Jul</option>
                                                            <option value="08">ส.ค. / Aug</option>
                                                            <option value="09">ก.ย. / Sep</option>
                                                            <option value="10">ต.ค. / Oct</option>
                                                            <option value="11">พ.ย. / Nov</option>
                                                            <option value="12">ธ.ค. / Dec</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="mt-1">
                                                {/* terms01 */}
                                                <div>
                                                    <h3 className="text-xs text-bold color-textBlackSoft">
                                                        <span className="sb-heading--medium Sarabun_fontthai">
                                                            เงื่อนไขและข้อตกลง
                                                        </span>
                                                        <br />
                                                        <span className="sb-heading--xsmall">
                                                            TERMS OF USE
                                                        </span>
                                                    </h3>
                                                    <label className="option option--checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="option__input hiddenVisually"
                                                            name="Terms01"
                                                            checked={Terms01}
                                                            onChange={this.handleChange}
                                                        />
                                                        <span className="flex option__label">
                                                            <span className="flex-shrink-none">
                                                                <span className="block option__labelMarker">
                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        className="valign-middle block option__labelIcon"
                                                                        preserveAspectRatio="xMidYMid meet"
                                                                        aria-hidden="true"
                                                                        focusable="false"
                                                                        style={{
                                                                            width: "22px",
                                                                            height: "22px",
                                                                            overflow: "visible"
                                                                        }}
                                                                    >
                                                                        <path d="M4.29 12.104c-.277-.308-.75-.332-1.06-.054-.306.278-.33.752-.053 1.06l4.485 4.963c.29.322.795.33 1.096.017L20.414 6.003c.288-.298.28-.773-.02-1.06-.297-.288-.772-.28-1.06.02L8.237 16.47 4.29 12.105z"></path>
                                                                    </svg>
                                                                </span>
                                                            </span>
                                                            <span className="option__labelText Sarabun_fontthai">
                                                                ยอมรับเงื่อนไขและข้อตกลง
                                                                <br />
                                                                I accept the terms of use.
                                                                <br />
                                                                <span className="inline-block mt3 color-textBlackSoft Sarabun_fontthai">โปรดอ่านข้อกำหนดการใช้เว็บไซต์นี้อย่างละเอียดก่อนเข้าใช้งาน เนื่องจากการเข้าใช้นี้หมายถึงคุณได้ยอมรับข้อกำหนดและเงื่อนไขโปรแกม Starbucks® Rewards, เงื่อนไขการใช้บัตรสตาร์บัคส์ การ์ด, ข้อกำหนดและเงื่อนไขการใช้งาน Mobile Application</span> <br /><br /><span className="inline-block mt3 color-textBlackSoft">By joining, I agree to the Terms, including the Starbucks® Rewards Terms, Starbucks Card Account Terms, Mobile Application Terms and Privacy Policy. Please read the Terms of Use carefully before accepting.</span>
                                                                <span className="inline-block mt3 color-textBlackSoft"><a className="color-greenStarbucks color-greenStarbucks" href="https://www.starbuckscardth.in.th/THHome/TermsAndConditions" target="_blank"><span className="Sarabun_fontthai text-bold">ข้อกำหนดในการใช้งาน /</span> Terms of Use</a></span>
                                                            </span>
                                                        </span>
                                                    </label>
                                                    <span className="req Sarabun_fontthai"></span>
                                                </div>

                                                {/* terms02 */}
                                                <div className="mt5">
                                                    <h3 className="text-xs text-bold color-textBlackSoft">
                                                        <span className="sb-heading--medium Sarabun_fontthai">
                                                            ความประสงค์ในการรับข้อมูลข่าวสาร
                                                        </span>
                                                        <br />
                                                        <span className="sb-heading--xsmall">
                                                            EMAIL PREFERENCE & TERMS
                                                        </span>
                                                    </h3>
                                                    <div>
                                                        <label className="option option--checkbox">
                                                            <input
                                                                type="checkbox"
                                                                className="option__input hiddenVisually"
                                                                name="Terms02"
                                                                checked={Terms02}
                                                                onChange={this.handleChange}
                                                            />
                                                            <span className="flex option__label">
                                                                <span className="option__labelText Sarabun_fontthai">
                                                                    ข้าพเจ้าไม่ประสงค์จะรับข้อมูลข่าวสารทางการตลาด <br />
                                                                    ผ่านช่องทางอีเมลหรือ sms จากสตาร์บัคส์ประเทศไทย<br />
                                                                    I do not wish to receive any direct marketing <br />
                                                                    (email, <span className="text-small">SMS</span>, etc.) communications from Starbucks Thailand.<br />
                                                                    <span className="inline-block mt3 color-textBlackSoft Sarabun_fontthai">โปรดทราบ: หากคุณเลือกไม่รับข่าวสาร สตาร์บัคส์ประเทศไทย จะไม่สามารถส่งข้อมูลข่าวสารและสิทธิพิเศษสำหรับสมาชิกให้คุณได้ คุณจะได้รับเพียงข้อมูลที่เกี่ยวกับสถานะและสิทธิประโยชน์ของสมาชิก Starbucks® Rewards เท่านั้น</span><br /><br /><span className="inline-block mt3 color-textBlackSoft">Please note that if you are a Starbucks® Rewards member and you opt out of receiving direct marketing communications (email, <span className="text-small">SMS</span>, etc.) from us, you will receive only membership program.</span>
                                                                </span>
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <span className="text-danger"></span>
                                                </div>
                                            </div>
                                            <div className="text-center">
                                                <button
                                                    className="btn btn-primary rounded-pill px-4 w-100"
                                                    type="submit"
                                                    name="theButton"
                                                    disabled={submitting}
                                                >
                                                    <span className="text-sm Sarabun_fontthai text-bold">
                                                        ลงทะเบียน
                                                    </span>
                                                    <br />
                                                    <span className="text-xxs text-bold">
                                                        Join Now
                                                    </span>
                                                </button>
                                                <span className="text-danger">{loginstatus}</span>                                                

                                                {/* modal */}
                                                {showBirthdayModal && (
                                                    <div className="modal show" id="birht_day_alert" style={{ display: 'block' }} aria-modal="true" role="dialog">
                                                        <div className="modal-dialog modal-lg modal-dialog-centered">
                                                            <div className="modal-content">
                                                                <div className="modal-header">
                                                                    <button type="button" className="btn-close" onClick={this.closeBirthdayModal} />
                                                                </div>
                                                                <div className="modal-body">
                                                                    <section className="section-collect2 bg-white">
                                                                        <div className="container">
                                                                            <div className="row justify-content-center">
                                                                                <div className="col-md-8 mb-2 p-0">
                                                                                    <p>เพื่อไม่ให้พลาดรับสิทธิพิเศษในวันเกิดเมื่อคุณได้ปรับระดับเป็น Gold กรุณาใส่ วันและเดือนเกิดของคุณ</p>
                                                                                    <p>Birthday rewards are one of the perks for Gold <br />
                                                                                        level members. Are you sure you want to leave your birthday blank?</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </section>
                                                                </div>
                                                                <div className="modal-footer justify-content-center">
                                                                    <a type="button" className="btn btn-secondary text-center text-white" onClick={this.confirmSkipBirthday}>ไม่ใส่/Yes</a>
                                                                    <a type="button" className="btn btn-primary text-center" onClick={this.goFillBirthday}>ใส่/No</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {/* The Modal */}

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <ZPartnerLSC0Footer />
            </>

        );
    }
}
